import { Component } from '@angular/core';
import { soundpostProductGLAccountDimensionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Product GL Account Dimensions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostproductglaccountdimension-form',
    templateUrl: './soundpostproductglaccountdimension.form.component.html'
})
export class soundpostProductGLAccountDimensionFormComponent extends BaseFormComponent {
    public record!: soundpostProductGLAccountDimensionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

